import { render, staticRenderFns } from "./form-setting.vue?vue&type=template&id=b687272a&scoped=true"
import script from "./form-setting.vue?vue&type=script&lang=js"
export * from "./form-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b687272a",
  null
  
)

export default component.exports